<template>
  <div>
    <notifications></notifications>
    <router-view></router-view>

    <div class="portal-modals">
      <portal-target name="modals"></portal-target>
    </div>
    <Modals/>
    <transition name="fade-trans">
      <div v-if="loading" class="loading-wrapper" id="handling-promise">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </transition>

    <FsLightbox v-if="sources && sources.length"
      :toggler="toggler"
      :sources="sources"
      :type="lightboxType"
      :onClose="close"
    />

    <portal-target name="settings-root"></portal-target>
    <portal-target name="root"></portal-target>
  </div>
</template>

<script>

import { mapState } from "vuex"

import Modals from "./layout/Modals/Modals.vue"

import FsLightbox from "fslightbox-vue"

export default {
  components: {
    Modals,

    FsLightbox,
  },
  data() {
    return {
      toggler: false,
    }
  },
  methods: {
    close(val) {
      if(!val) this.$store.commit("lightboxZoom", null)
    },
  },
  computed: {
    ...mapState({
      loading: state => state.loading,
      sources: state => state.lightboxSources,
      lightboxType: state => state.lightboxType
    }),
  },
  watch: {
    sources(val) {
      if (val) this.$nextTick(() => this.toggler = !this.toggler)
    },
  },
}

</script>

<style>

.qty-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 1000px;
  background-color: #0081C9;
  width: 25px;
  height: 25px;
  color: white;
}

.v-date-picker-table {
  height: 275px !important;
}

.delete-icon:hover {
  cursor: pointer;
  color: #dc3545;
}

.alert {
  font-size: 14px !important;
}

.alert .alert-icon {
  transform: translateY(3px);
}

.col-xl-8 {
  padding-top: 0;
  padding-bottom: 0;
}

.row {
  /* margin: 0 !important; */
}

.card {
  /* margin: 0 !important; */
}

.v-date-picker-table {
  height: 275px !important;
}

</style>

<style lang="scss">

.portal-modals {
  position: relative;
  z-index: 49;
}

.loading-wrapper {
  position: fixed;
  z-index: 9999;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0,0,0,.2);
}

.fade-trans-enter-active, .fade-trans-leave-active {
  transition: opacity .12s;
}
.fade-trans-enter, .fade-trans-leave-to {
  opacity: 0 !important;
}

.fade-trans-leave, .fade-trans-enter-to {
  opacity: 1 !important;
}

  .vue-notifyjs.notifications{
    .list-move {
      transition: transform 0.3s, opacity 0.4s;
    }
    .list-item {
      display: inline-block;
      margin-right: 10px;

    }
    .list-enter-active {
      transition: transform 0.2s ease-in, opacity 0.4s ease-in;
    }
    .list-leave-active {
      transition: transform 1s ease-out, opacity 0.4s ease-out;
    }

    .list-enter {
      opacity: 0;
      transform: scale(1.1);

    }
    .list-leave-to {
      opacity: 0;
      transform: scale(1.2, 0.7);
    }
  }
</style>
